import { PageHero } from "@/components/PageHero";
import { Stagger, StaggerItem } from "@/components/Reveal";
import { IMG, TEAM } from "@/data/site";

export default function Team() {
  return (
    <div data-testid="team-page">
      <PageHero overline="Meet Our Team" title="The people behind the welcome" subtitle="Hospitality is human. Meet the leadership of Zuri Sana." image={IMG.hotelBungalows} />
      <section className="py-24 md:py-32 max-w-7xl mx-auto px-6 md:px-12">
        <Stagger className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {TEAM.map((member) => (
            <StaggerItem key={member.name}>
              <div className="bg-[#121212] border hairline p-8 h-full group hover:border-[#d4af37]/40 transition-colors duration-500" data-testid={`team-card-${member.initials.toLowerCase()}`}>
                <div className="h-20 w-20 rounded-full bg-gradient-to-br from-[#d4af37] to-[#8a6d24] flex items-center justify-center mb-6">
                  <span className="font-serif-display text-2xl text-black font-medium">{member.initials}</span>
                </div>
                <h3 className="font-serif-display text-2xl font-light text-white">{member.name}</h3>
                <p className="text-xs uppercase tracking-[0.25em] text-[#d4af37] mt-2">{member.role}</p>
                <p className="mt-4 text-sm text-[#a3a3a3] leading-relaxed">{member.bio}</p>
              </div>
            </StaggerItem>
          ))}
        </Stagger>
      </section>
    </div>
  );
}
